module.exports = __webpack_public_path__ + "static/1-create-organization-29fc924dc1cbd1a4299da12b15a2ae83.png";